import { Link } from 'react-router';
import { ArrowRight } from 'lucide-react';
import { PRICE_NOTE } from '@/data/homeContent';
import { useRates } from './usePublicContent';

export const PriceList = () => {
  const { rates } = useRates();

  return (
  <section id="arak" aria-labelledby="arak-cim" className="scroll-mt-24 py-16 sm:py-20">
    <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
      <div className="mb-10 max-w-[56ch]">
        <h2 id="arak-cim" className="text-2xl">
          Mit lehet bérelni, és mennyiért?
        </h2>
        <p className="mt-3 text-ink-soft">
          Minden ágyunkat kiszállítás előtt átvizsgáljuk, a matracokat pedig minden bérlés után
          kimosatjuk és fertőtlenítjük.
        </p>
      </div>

      <ul className="list-none border-t-2 border-navy p-0">
        {rates.map((rate) => (
          <li
            key={rate.name}
            className="grid gap-4 border-b border-line py-7 md:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)_auto] md:items-center md:gap-8"
          >
            <div>
              <h3 className="text-lg">
                <Link to={rate.href} className="inline-flex min-h-11 items-center gap-2 text-navy no-underline hover:text-teal-ink">
                  {rate.name}
                  <ArrowRight className="size-5 text-teal-ink" aria-hidden="true" />
                </Link>
              </h3>
              <p className="text-sm text-teal-ink">{rate.kind}</p>
            </div>

            <p className="text-ink-soft">{rate.description}</p>

            <p className="whitespace-nowrap md:text-right">
              <span className="block font-display text-xl font-bold text-navy">{rate.priceLabel}</span>
              <span className="text-sm text-ink-soft">{rate.unitLabel}</span>
            </p>
          </li>
        ))}
      </ul>

      <p className="mt-6 border-l-4 border-teal pl-4 text-sm text-ink-soft">{PRICE_NOTE}</p>
    </div>
  </section>
  );
};
